import useSWR from "swr";

import { RelationshipType } from "@resource/models";

import { resourceEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export function useGetResourcesRelationshipTypes() {
  const url = resourceEndpoints.getResourcesRelationshipTypes();

  const fetcherWithToken = (url: string) => fetcher<RelationshipType[]>(url);

  const { data, error, isLoading } = useSWR(url, fetcherWithToken);

  return {
    data,
    isLoading,
    error
  };
}
